import { useTranslation } from 'react-i18next';

import { useReactiveVar } from '@apollo/client';
import {
    conversationDetailsVar,
    subsidiarySiteVar,
} from '@boot/reactiveVariables';

export const useReportDetails = () => {
    const { t } = useTranslation();

    const { investigationEntity, subsidiarySite } =
        useReactiveVar(subsidiarySiteVar) || {};
    const conversationDetailsData = useReactiveVar(conversationDetailsVar);
    const country = conversationDetailsData?.country.label;
    const incidentType = conversationDetailsData?.incidentTypeUuid.label;
    const excludedManagers =
        conversationDetailsData?.caseExclusionOwnerList?.map(
            (item) => item.label || '',
        );

    const additionalDetails = [
        ...(subsidiarySite
            ? [
                  {
                      key: subsidiarySite.label,
                      title: t('SUBSIDIARY'),
                      value: subsidiarySite.label,
                  },
              ]
            : []),
        ...(investigationEntity
            ? [
                  {
                      key: investigationEntity,
                      title: t('ADDITIONAL_DETAILS_INVESTIGATION'),
                      value: investigationEntity
                          .replace(
                              /\S*/g,
                              (word) =>
                                  `${word.slice(0, 1)}${word
                                      .slice(1)
                                      .toLowerCase()}`,
                          )
                          .replace('_', ' '),
                  },
              ]
            : []),
        ...(country
            ? [
                  {
                      key: country,
                      title: t('COUNTRY_INCIDENT'),
                      value: country,
                  },
              ]
            : []),
        ...(incidentType
            ? [
                  {
                      key: incidentType,
                      title: t('INCIDENT_TYPE'),
                      value: incidentType,
                  },
              ]
            : []),
    ];

    return {
        additionalDetails,
        conversationDetailsData,
        excludedManagers,
    };
};
